import { render } from "./Navigation-block.vue?vue&type=template&id=89934664&scoped=true"
import script from "./Navigation-block.vue?vue&type=script&lang=js"
export * from "./Navigation-block.vue?vue&type=script&lang=js"

import "./Navigation-block.vue?vue&type=style&index=0&id=89934664&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89934664"]])

export default __exports__